/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Preset_Manager_Import_TitleInputs */



/**
* | output |
* | --- |
* | "Import Presets" |
*
* @param {Preset_Manager_Import_TitleInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const preset_manager_import_title = /** @type {((inputs?: Preset_Manager_Import_TitleInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Preset_Manager_Import_TitleInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Importer des presets")
	if (locale === "de") return /** @type {LocalizedString} */ ("Import-Voreinstellungen")
	if (locale === "it") return /** @type {LocalizedString} */ ("Importa preset")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Импорт пресетов")
	if (locale === "es") return /** @type {LocalizedString} */ ("Importar ajustes preestablecidos")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("导入预设")
	if (locale === "ja") return /** @type {LocalizedString} */ ("プリセットをインポート")
	if (locale === "hi") return /** @type {LocalizedString} */ ("प्रीसेट आयात करें")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Importar predefinições")
	return /** @type {LocalizedString} */ ("Import Presets")
});